import {
  CHANGE_TREK_PAYMENT_TYPE,
  STORE_TREK_PAYMENT_DETAILS,
  CHANGE_TREK_TEMPLATE_START_DATE,
  SEARCH_FLIGHTS_IN_SELF_GUIDED_TREKS,
  STORE_FLIGHTS_FOR_SELF_GUIDED_TREKS,
  CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE,
  SELECT_GUIDE_TYPE,
  UPDATE_NUMBER_OF_PORTER,
  LOADING_STATE_FOR_TREK_REVIEW,
  STORE_NO_FLIGHTS,
} from '../actions/types';

const INITIAL_STATE = {
  lodgings: [],
  flights: [],
  paymentType: 'R',
  noOfPeople: 1,
  trekTemplateStartDate: '',
  isLoading: false,
  outbound: null,
  inbound: null,
  userIsPickingDatesOrPax: true,
  noOfPorter: 0,
  selectedGuideType: 'none',
  isFlightsAvailable: null,
  sessionId: null,
};

export default (state = INITIAL_STATE, action) => {
  const {
    payload,
    inbound,
    tripType,
    outbound,
    noOfPeople,
    noOfPorter,
    paymentType,
    trekStartDate,
    sessionId,
    selectedGuideType,
    loadingState,
    isFlightsAvailable,
  } = action;

  switch (action.type) {
    case STORE_TREK_PAYMENT_DETAILS:
      return { ...state, ...payload };

    case CHANGE_TREK_PAYMENT_TYPE:
      return { ...state, paymentType };

    case CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE:
      return { ...state, noOfPeople, userIsPickingDatesOrPax: true };

    case CHANGE_TREK_TEMPLATE_START_DATE:
      return {
        ...state,
        trekTemplateStartDate: trekStartDate,
        userIsPickingDatesOrPax: true,
      };

    case SEARCH_FLIGHTS_IN_SELF_GUIDED_TREKS:
      return { ...state, isLoading: true };

    case STORE_FLIGHTS_FOR_SELF_GUIDED_TREKS:
    case STORE_NO_FLIGHTS:
      return {
        ...state,
        outbound,
        inbound,
        tripType,
        sessionId,
        isLoading: false,
        isFlightsAvailable,
        userIsPickingDatesOrPax: false,
      };

    case UPDATE_NUMBER_OF_PORTER:
      return { ...state, noOfPorter };

    case SELECT_GUIDE_TYPE:
      return { ...state, selectedGuideType };

    case LOADING_STATE_FOR_TREK_REVIEW:
      return { ...state, isLoading: loadingState };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/trekPaymentReducer.js